import {
	IconBrandFacebook,
	IconBrandInstagram,
	IconBrandLinkedin,
	IconBrandTiktok,
	IconBrandX,
	IconBrandYoutube,
	type TablerIcon,
} from "@tabler/icons-react"
import { type ComponentType, type FC, type SVGProps } from "react"

import type { FooterSocialPlatform } from "@forento/core/models/landing"

// Tabler has no Substack mark, so this one is drawn on its 24px stroke grid to sit next to the rest.
const IconBrandSubstack: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={2}
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M4 4h16" />
		<path d="M4 8h16" />
		<path d="M4 12v9l8-4 8 4v-9z" />
	</svg>
)

const footerSocialIconComponents: Record<FooterSocialPlatform, TablerIcon | ComponentType<SVGProps<SVGSVGElement>>> = {
	x: IconBrandX,
	facebook: IconBrandFacebook,
	instagram: IconBrandInstagram,
	tiktok: IconBrandTiktok,
	youtube: IconBrandYoutube,
	linkedin: IconBrandLinkedin,
	substack: IconBrandSubstack,
}

type Props = { platform: FooterSocialPlatform; className?: string }
const FooterSocialIcon: FC<Props> = ({ platform, className }) => {
	const Icon = footerSocialIconComponents[platform]
	return <Icon aria-hidden="true" className={className} />
}

export default FooterSocialIcon
